import { Container } from '@/components/Shared/Layout/Container';
import { SwiperNav } from '@/components/Shared/Swiper/SwiperNav';
import { TextTestimonial } from '@/components/Shared/TextTestimonial';
import { ITestimonials } from '@/utils/interfaces/bloks';
import { useState } from 'react';
import { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FormattedText } from '../Shared/FormattedText';
import { SbSection } from '../Shared/Layout/SbSection';
import { useRouter } from 'next/router';

interface IProps {
	blok: ITestimonials;
	preview: boolean;

}

export const TextTestimonials: React.FC<IProps> = ({ blok, preview }) => {
	const [prevEl, setPrevEl] = useState<HTMLElement | null>(null);
	const [nextEl, setNextEl] = useState<HTMLElement | null>(null);
	const [paginationRef, setPaginationRef] = useState<HTMLElement | null>(null);

	const router = useRouter();
	const currentPath = router.asPath.split('?')[0].replace(/\/$/, '');
	const isHomeRevamp = currentPath.endsWith('/home-revamp');

	const sectionClasses = ['relative py-[70px] bg-white  overflow-hidden'];
	const copyClasses = ['mt-4 lg:text-xl max-w-[600px]'];
	if (blok.style === 'light') {
		sectionClasses.push('bg-light');
		copyClasses.push('text-gray-dark/80');
	} else if (blok.style === 'dark') {
		sectionClasses.push('bg-green-dark text-white');
	}

	return (
		<SbSection
			blok={blok}
			preview={preview}
			classNames={sectionClasses.join(' ')}
		>
			<Container>
				<h2 className="font-bold md:text-7xl text-center mb-[50px]">
					<span className="text-green">What Canibuild&nbsp;</span>
					<span>Users Say</span>
				</h2>

				<div className="overflow-hidden">
					<Swiper
						modules={[Navigation, Pagination]}
						navigation={{ prevEl, nextEl }}
						pagination={{
							el: paginationRef,
							type: 'fraction',
						}}
						spaceBetween={24}
						slidesPerView={1}
						breakpoints={{
							768: {
								slidesPerView: 2,
							},
						}}
					>
						{blok.testimonials.slice(0, 2).map((testimonial, key) => (
							<SwiperSlide className="flex h-auto min-h-[230px]" key={key}>
								<TextTestimonial blok={testimonial} isLarge={true} />
							</SwiperSlide>
						))}
					</Swiper>
				</div>
			</Container>
		</SbSection>
	);
};
